export default __webpack_public_path__ + "static/media/logo.49f67f25.png";